<template>
  <div class="product-legals">
    <div class="my-3" :loading="loading">{{ calculated.volume }}</div>
    <div
      class="c-gray font-size-s"
      v-html="translate('fe_app_tax_info', product.tax, 'link-gray')"
      :loading="loading"
    />
  </div>
</template>

<script>
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'

export default {
  name: 'Legals',
  computed: {
    ...mapState(usePdpStore, {
      product: 'getApiProduct',
      calculated: 'getCalculated',
      loading: 'isUpdating'
    })
  }
}
</script>
